module.exports = __webpack_public_path__ + "img/Postco.ba81c27a.png";